import React from 'react';
import PropTypes from 'prop-types';

import Assets from '@app/assets';

const animationDelay = `-${Math.floor(Math.random() * 2.5)}s`;
const renderAnimation = (innerCircleColor) => {
  const style = {
    backgroundColor: innerCircleColor,
  };
  return (
    <div className="preview__loading-animation">
      <div className="preview__loading-outer" />
      <div className="preview__loading-inner" style={style} />
    </div>
  );
};

const Loader = ({
  animation,
  backgroundColor,
  image,
  pulseEnabled,
  innerCircleColor,
}) => {
  const style = {
    backgroundColor,
  };

  if (pulseEnabled === true) {
    style.animationDelay = animationDelay;
  } else {
    style.animation = 'none';
  }

  return (
    <div className="preview__loading" style={style}>
      {animation && renderAnimation(innerCircleColor)}
      {!!image && <img src={Assets.lookup(image)} />}
    </div>
  );
};

Loader.propTypes = {
  animation: PropTypes.bool,
  backgroundColor: PropTypes.string,
  image: PropTypes.string,
  pulseEnabled: PropTypes.bool,
  innerCircleColor: PropTypes.string,
};

Loader.defaultProps = {
  animation: true,
  backgroundColor: 'none',
  pulseEnabled: false,
  innerCircleColor: '#F7F9FA',
};

export default Loader;
